module.exports = __webpack_public_path__ + "static/antd-table-compact-94b20cc78c1d3fe1094e056cc6800953.png";